<template>
  <div
    class="flex flex-col justify-between p-20 rounded-xl border border-neutral-100/5 bg-white"
  >
    <div class="flex items-start gap-8 pb-16">
      <p class="flex-1 text-headline-3 !font-medium text-neutral-100">
        {{ pilar.name }}
      </p>

      <span class="flex items-center justify-center size-20 shrink-0">
        <q-icon
          name="svguse:#icon_info_circle"
          size="20px"
          class="text-[#84878E] cursor-pointer"
        >
          <q-tooltip
            anchor="top right"
            self="bottom right"
            :offset="[10, 8]"
            class="overflow-visible bg-[#202227] p-12 rounded-[6px] shadow-xlarge"
          >
            <div class="flex flex-col gap-10">
              <div class="flex items-center gap-6">
                <span
                  class="block w-[3px] h-12 rounded-lg"
                  :style="{ backgroundColor: pilar.color }"
                />
                <span
                  class="text-caps-2 !font-normal text-[#9F9FA0] uppercase whitespace-nowrap"
                >
                  {{ pilar.name }}
                </span>
              </div>

              <div class="flex items-baseline gap-8 whitespace-nowrap">
                <span class="text-headline-2 !font-medium text-white">
                  {{ pilar.weight }}
                </span>
                <span class="text-headline-3 !font-medium text-[#9F9FA0]">
                  Peso do pilar
                </span>
              </div>
            </div>

            <q-icon
              name="svguse:#icon_tooltip_arrow|0 0 12.4142 5.58579"
              class="!absolute right-[13.8px] bottom-[-5px] !w-[12.4px] !h-[5.6px] text-[#202227]"
            />
          </q-tooltip>
        </q-icon>
      </span>
    </div>

    <div class="flex items-center flex-nowrap gap-32 2xl:gap-16">
      <div class="relative grid place-items-center size-[6.5rem] shrink-0">
        <svg
          class="absolute inset-0 -rotate-90"
          width="104"
          height="104"
          viewBox="0 0 104 104"
          fill="none"
        >
          <circle
            cx="52"
            cy="52"
            :r="RING_RADIUS"
            stroke="#EFEFEF"
            stroke-width="8"
          />
          <circle
            v-if="pilar.percent > 0"
            cx="52"
            cy="52"
            :r="RING_RADIUS"
            :stroke="pilar.color"
            stroke-width="8"
            stroke-linecap="round"
            :stroke-dasharray="RING_LENGTH"
            :stroke-dashoffset="RING_LENGTH * (1 - pilar.percent)"
            class="pilar-ring-progress"
            :style="{
              '--ring-length': RING_LENGTH,
              '--ring-delay': `${index * 80}ms`,
            }"
          />
        </svg>

        <span
          class="relative text-title-3 !font-medium text-neutral-100 whitespace-nowrap"
        >
          {{ pilar.percentLabel }}
        </span>
      </div>

      <div class="flex flex-col gap-12 whitespace-nowrap">
        <div class="flex flex-col gap-2">
          <span class="text-paragraph-3 !font-light text-neutral-70">
            Pontos possíveis
          </span>
          <strong class="text-headline-3 !font-medium text-neutral-100">
            {{ pilar.possiblePoints }}
          </strong>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-paragraph-3 !font-light text-neutral-70">
            Pontos feitos
          </span>
          <strong class="text-headline-3 !font-medium text-neutral-100">
            {{ pilar.points }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  pilar: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    default: 0,
  },
})

const RING_RADIUS = 48
const RING_LENGTH = 2 * Math.PI * RING_RADIUS
</script>

<style lang="scss" scoped>
.pilar-ring-progress {
  animation: pilar-ring-fill 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;
  animation-delay: var(--ring-delay);
  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
  }
}

@keyframes pilar-ring-fill {
  from {
    stroke-dashoffset: var(--ring-length);
  }
}
</style>
